import {
  GET_PRE_ORDERS_REQUESTED,
  GET_PRE_ORDERS_SUCCEEDED,
  GET_PRE_ORDERS_FAILED,
} from './constants'
import DataMapper from '../../utils/dataMapper'

export const defaultState = {}

export default (state = defaultState, {type, payload}) => {
  switch (type) {
    case GET_PRE_ORDERS_REQUESTED:
      return { ...state, isLoading: true }

    case GET_PRE_ORDERS_SUCCEEDED:
      const byId = DataMapper.objectsById(payload)

      return {
        ...state,
        byId,
        isLoading: false
      }

    case GET_PRE_ORDERS_FAILED:
      return { ...state, isLoading: false }

    default:
      return state
  }
}
